import React from 'react';
import { useStoreon } from 'storeon/react';
import { RootLayout } from 'common/components';
import { COOKIES_STORE_NAME } from 'modules/cookies';
import { State } from 'store/types';
import { ExperimentCookie } from 'types/common';
import { Kitchen as KitchenVariantA } from './variant-a';
import { Kitchen as KitchenVariantB } from './variant-b';
import { KITCHEN_PATH, MODIFIED_KITCHEN_BREADCRUMBS } from './kitchen-constants';


/**
 * Вью страницы "Кухни"
 */
export const Kitchen = () => {
  const { cookies } = useStoreon<State>(COOKIES_STORE_NAME);
  const experimentCookie = (cookies._proekt_kuhni || 'A') as ExperimentCookie;

  return (
    <RootLayout customBreadcrumbs={MODIFIED_KITCHEN_BREADCRUMBS} currentPage={KITCHEN_PATH}>
      {experimentCookie === 'A' ? <KitchenVariantA /> : <KitchenVariantB />}
    </RootLayout>
  );
};
